var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    _vm._b(
      {
        staticClass: "btn py-0 px-1",
        class: [_vm.disabled ? "text-gray-400" : "bg-gray-hover-200"],
        attrs: { type: "button", disabled: _vm.disabled },
        on: { click: _vm.onClick },
      },
      "button",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }